<template>
  <task-page
    :resource="taskResource"
    :archivedResource="archivedResource"
    :obj-id="resId"
    :list-id="id || 'TaskListForCustomResourceSidePage'"
    :getParams="getParams"
    isSidepage
    :ignoreResId="ignoreResId"
    root />
</template>

<script>
import TaskPage from '@/sections/TaskPage'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'TaskDrawer',
  components: {
    TaskPage,
  },
  mixins: [WindowsMixin],
  props: {
    taskResource: {
      type: String,
      default: 'compute-tasks',
    },
    id: {
      type: String,
    },
    resId: {
      type: String,
    },
    getParams: [Object, Function],
    ignoreResId: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    archivedResource () {
      if (this.taskResource && this.taskResource.includes('-tasks')) {
        return this.taskResource.replace('-tasks', '-archivedtasks')
      }
      return ''
    },
  },
}
</script>
